<div class="d-flex box w-100 h-100 flex-wrap">
  <bdg-label
    [ngClass]="arquivos?.length ? 'w-100' : ''"
    class="py-2 px-3 align-self-center"
    type="body-1"
    [required]="required"
    >{{ title }}</bdg-label
  >

  <div *ngFor="let arquivo of arquivos" class="w-100 d-flex align-items-center py-1 px-3">
    <a href="javascript:void(0)" (click)="download(arquivo)" class="d-flex align-items-center">
      <div class="d-flex">
        {{ truncate(arquivo.nome, 30) }}
        <mat-icon class="ml-2" style="color: black; margin-top: -2px">get_app</mat-icon>
      </div>
    </a>
    <button mat-icon-button class="ml-2" (click)="removeFile(arquivo)" [disabled]="disabled">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngFor="let uploadingFile of uploadingFiles" class="w-100 d-flex align-items-center py-1 px-3">
    <div class="d-flex align-items-center">
      <div class="d-flex">
        {{ truncate(uploadingFile.file.name, 30) }}
      </div>
      <mat-spinner diameter="20" class="ml-2" hint="Enviando arquivo"></mat-spinner>
    </div>
  </div>

  <div class="py-2 px-3 ml-auto">
    <input id="file" type="file" class="d-none" #fileInput [accept]="accept" multiple (change)="onChange($event)" />
    <input matInput class="d-none" [formControl]="control" />
    <div class="d-flex">
      <bdg-button
        [disabled]="disabled"
        class="primary"
        label="ANEXAR ARQUIVO"
        matIcon="publish"
        (click)="onClick(fileInput)"
      >
      </bdg-button>
    </div>
  </div>
</div>

<mat-error class="mat-form-field" *ngIf="control?.parent?.invalid && (control?.dirty || control?.touched)">
  <span style="font-size: 0.8em; margin-top: 0.25em; letter-spacing: calc(0.05em - 0.2px)">
    {{ control?.errors ? Object.values(control.errors)[0] : null }}
  </span>
</mat-error>
